/* eslint-disable security/detect-object-injection */

import './QSFBoard.style.less'

import { Col, Row, Tabs } from 'antd'
import { LBF_DATE_PICKER, LBF_QUERY_KEY } from '../Liveboard.constant'
import { useState } from 'react'

import CombineCharts from '../components/CombineCharts/CombineCharts'
import FlipFingerContainer from '@/components/FlipFingerContainer/FlipFingerContainer'
import LBScoreCard from '../components/LBScoreCard/LBScoreCard'
import LiveboardFilter from '../components/LiveboardFilter/LiveboardFilter'
import LoadingComponent from '@/components/LoadingComponent/LoadingComponent'
import { Moment } from 'moment'
import { cloneDeep, get } from 'lodash'
import { getQSFFilter } from '../Liveboard.transform'
import { getTenantConfig } from '../util/LiveboardUtil'
import { useAuth } from '@/providers/auth.provider'
import { useQuery } from 'react-query'
import SkeletonLoading from '@/components/SkeletonLoading/SkeletonLoading'

const { useTransition } = require('react')

const { TabPane } = Tabs
function QSFBoard() {
  const { user } = useAuth()

  const [config, setconfig] = useState(null)
  const [charts, setcharts] = useState([])
  const [scorecard, setScoreCard] = useState([])
  const [loading, setloading] = useState(false)
  const [, setTransition] = useTransition()

  const [filter, setfilter] = useState<any>({})
  const [datePicked, setdatePicked] = useState<Moment[]>([])

  const [tabNavigation, settabNavigation] = useState([])

  useQuery(['liveboard_setting'], async () => {
    const tmpData = await getTenantConfig(user?.company?.id)
    initializeConfig(tmpData)
    setconfig(tmpData)
    return tmpData
  })

  const initializeConfig = (configData) => {
    const tmpTabNavigation = configData?.company?.tabs?.filter(
      (item) => item.module_key == 'qsf'
    )
    settabNavigation(tmpTabNavigation)
    const tab_key = get(tmpTabNavigation, '[0].key')
    const _chart = get(
      configData?.chart_layouts.find((item) => item.module_key == 'qsf'),
      'charts.charts',
      []
    )
      .filter((item) => item.tab_key == tab_key)
      .sort((a, b) => a.display_order - b.display_order)
    setcharts(_chart)
    const _scoreCard = get(
      configData?.chart_layouts.find((item) => item.module_key == 'qsf'),
      'charts.scorecards',
      []
    )
    setScoreCard(
      _scoreCard
        .filter((item) => item.tab_key == tab_key)
        .sort((a, b) => a.display_order - b.display_order)
    )
    setdatePicked(LBF_DATE_PICKER[3].date)
  }

  const onTabChange = (key: string) => {
    const tab_key = tabNavigation[parseInt(key)].key
    setloading(true)
    setTransition(() => {
      setcharts(
        config.chart_layouts
          .find((item) => item.module_key == 'qsf')
          .charts.charts.filter((item) => item.tab_key == tab_key)
          .sort((a, b) => a.display_order - b.display_order)
      )
      setScoreCard(
        config.chart_layouts
          .find((item) => item.module_key == 'qsf')
          .charts.scorecards.filter((item) => item.tab_key == tab_key)
          .sort((a, b) => a.display_order - b.display_order)
      )
      setloading(false)
    })
  }

  const { data: dataFilter, isLoading: loadingFilter } = useQuery(
    LBF_QUERY_KEY.QSF_FILTER_CATEGORY,
    () => {
      return getQSFFilter(user?.company?.id)
    }
  )

  return (
    <div className={'qsf-liveboard-container'}>
      {loadingFilter ? (
        <SkeletonLoading />
      ) : (
        <LiveboardFilter
          filters={config?.company.filters.filter(
            (item) => item?.module_key == 'qsf'
          )}
          data={dataFilter}
          onChange={(options: { filter: any; datePicked: Moment[] }) => {
            setfilter(cloneDeep(options.filter))
            setdatePicked(cloneDeep(options.datePicked))
          }}
        />
      )}

      <Tabs defaultActiveKey="0" onChange={onTabChange}>
        {tabNavigation?.map((item, index) => {
          return (
            <TabPane tab={item.name} key={index}>
              {loading ? (
                <LoadingComponent />
              ) : (
                <>
                  <Row gutter={[20, 20]} style={{ marginBottom: 20 }}>
                    {scorecard?.map((item, index) => (
                      <LBScoreCard
                        data={{
                          filter,
                          datePicked,
                        }}
                        item={item}
                        key={index}
                        index={index}
                        datePicked={datePicked}
                      />
                    ))}
                  </Row>
                  <Row gutter={[20, 20]}>
                    {charts?.map((item, key) => {
                      if (item?.is_switchable) {
                        return (
                          <Col span={12} key={key}>
                            <FlipFingerContainer
                              frontComponent={
                                <CombineCharts
                                  item={item}
                                  options={{
                                    filter,
                                    datePicked,
                                  }}
                                />
                              }
                              backComponent={
                                <CombineCharts
                                  item={item.switch_chart}
                                  options={{
                                    filter,
                                    datePicked,
                                  }}
                                />
                              }
                            />
                          </Col>
                        )
                      }
                      return (
                        <Col span={12} key={key}>
                          <CombineCharts
                            key={key}
                            item={item}
                            options={{
                              filter,
                              datePicked,
                            }}
                          />
                        </Col>
                      )
                    })}
                  </Row>
                </>
              )}
            </TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}
export default QSFBoard
